import * as React from 'react'
const SvgEllipseDark = React.forwardRef<SVGSVGElement, React.SVGProps<SVGSVGElement>>(function SvgEllipseDark(
    props,
    svgRef,
) {
    return (
        <svg width="1em" height="1em" viewBox="0 0 9 8" fill="none" ref={svgRef} {...props}>
            <circle cx={4.493} cy={4} r={4} fill="#3C8EFF" />
        </svg>
    )
})
export default SvgEllipseDark
